import '../style.scss';

export default function CustomPrice() {
    return (
        <div className="price-custom">
            <i className="ic-email-filled" />
        </div>
    );
}
